import { render, staticRenderFns } from "./criteriasView.vue?vue&type=template&id=b6a9d5b4"
import script from "./criteriasView.vue?vue&type=script&lang=js"
export * from "./criteriasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports